<!--
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-08-17 15:59:55
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-12-01 18:13:55
 * @FilePath: \sea-page-game\src\components\footer\template.vue
-->
<!-- 
 * @description: 底部信息模块
 * @fileName: template.vue 
 * @author: 薛微微 
 * @date: 2023-06-21 17:11:40
!-->
<template>
  <div :class="{
    'mfooter': this.$Base.checkSysteam() == 'MOBILE',
    'footer': this.$Base.checkSysteam() != 'MOBILE',
    'mfooter-vn': this.$Base.langPicClass() == 'vi-VN' && this.$Base.checkSysteam() == 'MOBILE'
  }" v-if="isShow">
    <div class="foot_cont">
      <template v-if="this.$Base.langPicClass() == 'vi-VN' && this.$Base.checkSysteam() == 'MOBILE'">
        <div class="foot_icon_vn">
          <i class="vi-icon" v-if="this.$Base.langPicClass() == 'vi-VN' && this.$Base.checkSysteam() == 'MOBILE'">
            <img src="../../assets/vi/logo.png" alt="" />
          </i>
          <i class="icon" v-if="this.$Base.langPicClass() == 'vi-VN' || this.$Base.checkSysteam() == 'MOBILE'">
            <img src="../../assets/foot-icon.png" alt="" />
          </i>
        </div>
      </template>
      <template v-else>
        <i class="vi-icon" v-if="this.$Base.langPicClass() == 'vi-VN' && this.$Base.checkSysteam() == 'PC'">
          <img src="../../assets/vi/logo.png" alt="" />
        </i>
        <i class="icon" v-if="this.$Base.langPicClass() == 'vi-VN' || this.$Base.checkSysteam() == 'PC'">
          <img src="../../assets/foot-icon.png" alt="" />
        </i>
      </template>

      <div>
        <div class="foot_btn">
          <a :title="$t('message.rules_clause')" @click="protocolUrl(1)">{{
            $t("message.rules_clause")
          }}</a>
          <span>|</span>
          <a :title="$t('message.privacy_clause')" @click="protocolUrl(2)">{{
            $t("message.privacy_clause")
          }}</a>
        </div>
        <template v-if="this.$Base.langPicClass() == 'vi-VN'">
          <p class="p p-left">
            Công ty Cổ phần Wetaps
          </p>
          <p class="p p-left">
            Địa chỉ: 22 Hồng Hà, Phường 2, Quận Tân Bình, TP Hồ Chí Minh
          </p>
          <p class="p p-left">
            Bản quyền trò chơi thuộc về Rastar Games (HK) Co., Ltd và Công ty Cổ phần Wetaps phân phối độc quyền tại Việt
            Nam
          </p>
          <p class="p p-left">
            Quyết định phê duyệt kịch bản phát hành trò chơi số 2143/QĐ-BTTTT do Bộ TTTT cấp ngày 06 tháng 11 năm 2023
          </p>
        </template>
        <template v-else>
          <p class="p" id="copy_text">
            {{ $t("message.service_email") }}{{ this.NetbarNumber }}
          </p>
          <p class="bq">© NEXON Korea Corp.All Rights Reserved</p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RastarFooter",
  data() {
    return {
      NetbarNumber: this.$t("message.EmailAddress"),
      fullHeight: document.documentElement.clientHeight, //视口高
      isShow: true,
    };
  },
  methods: {
    protocolUrl: function (val) {
      if (val == 1) {
        window.open(this.$Storage.localStorageGet("user_protocol"), "_blank");
      } else {
        window.open(
          this.$Storage.localStorageGet("private_protocol"),
          "_blank"
        );
      }
    },
  },
  created() { },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        that.fullHeight = window.fullHeight;
      })();
    };
  },
  watch: {
    fullHeight(val) {
      if (!this.timer) {
        this.fullHeight = val;
        console.log("fullHeight", this.fullHeight);
        let system = this.$Base.checkSysteam();
        if (this.fullHeight < 400 && system == "MOBILE") {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
